import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class EstacionariosService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/credigasEstacionarios';
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public get(idCreditos : number){
    const service = this.service_url + '/' + idCreditos;
    return this.http.get(service  , this.authService.getAuthHeaders());
  }

  public validate(credito : any){
    let error = [];
    let prestamo = credito.prestamo;
    let cliente = credito.cliente;
    let estacionario = credito.estacionario;

    if(!this.validatorService.required(prestamo.monto_prestamo)){
        error["monto_prestamo"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.plazo_periodo)){
        error["plazo_periodo"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.tasa)){
        error["tasa"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.email)){
        error["email"] = this.errorService.required;
    }else if (!this.validatorService.email(cliente.email)) {
        error['email'] = this.errorService.email;
    }

    if(!this.validatorService.required(estacionario.consumo)){
        error["consumo"] = this.errorService.required;
    }

    if(!this.validatorService.required(estacionario.factor_recaudo)){
      error["factor_recaudo"] = this.errorService.required;
  }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/estacionarios.service.ts